import { Modal, ModalProps, Paper, PaperProps, SxProps, Theme } from '@mui/material';
import { styles } from './styles';

interface IBaseModalProps extends Omit<ModalProps, 'children'> {
  containerProps?: PaperProps;
  children: React.ReactNode;
}

export const BaseModal = ({ containerProps, children, ...modalProps }: IBaseModalProps) => (
  <Modal {...modalProps}>
    <Paper
      {...containerProps}
      sx={(theme) => ({
        ...(styles?.defaultContainer as (theme: Theme) => SxProps)(theme),
        ...containerProps?.sx,
      })}
    >
      {children}
    </Paper>
  </Modal>
);
